/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./incomingwebhook.vue?vue&type=template&id=60c06aec&scoped=true"
import script from "./incomingwebhook.vue?vue&type=script&lang=js"
export * from "./incomingwebhook.vue?vue&type=script&lang=js"
import style0 from "./incomingwebhook.vue?vue&type=style&index=0&id=60c06aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c06aec",
  null
  
)

export default component.exports